export const svgWidgetDimensions = { width: 250, height: 220 };

export const svgWidgetMargins = {
  top: 40,
  right: 50,
  bottom: 45,
  left: 70,
};

export const svgWidgetMobileMargins = {
  top: 20,
  right: 15,
  bottom: 35,
  left: 15,
};

export const ticksConfigWidgetMobile = {
  dx: {
    tickSize: 15,
    tickLengthOffset: 0,
  },
  dy: {
    tickSize: 15,
    tickLengthOffset: 15,
    ticksNumber: 4,
  },
};
